import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type UserRole = 'admin' | 'therapist';

export interface ManagedUser {
  uid: string;
  email: string | null;
  displayName: string | null;
  photoURL: string | null;
  disabled: boolean;
  role: UserRole;
  patientCount: number;
  lastSignInAt: string | null;
  createdAt: string | null;
}

const _listUsers = httpsCallable<void, { users: ManagedUser[] }>(functions, 'listUsers');
const _setUserDisabled = httpsCallable<{ uid: string; disabled: boolean }, { uid: string; disabled: boolean }>(
  functions,
  'setUserDisabled'
);
const _setUserRole = httpsCallable<{ uid: string; role: UserRole }, { uid: string; role: UserRole }>(
  functions,
  'setUserRole'
);
const _reassignPatient = httpsCallable<
  { patientId: string; newOwnerId: string },
  { patientId: string; newOwnerId: string }
>(functions, 'reassignPatient');
const _createTherapist = httpsCallable<
  { email: string; password: string; displayName?: string },
  { uid: string }
>(functions, 'createTherapist');
const _updateTherapist = httpsCallable<
  { uid: string; email: string; displayName?: string },
  { uid: string }
>(functions, 'updateTherapist');

export async function listUsers(): Promise<ManagedUser[]> {
  const res = await _listUsers();
  return res.data.users;
}

export async function setUserDisabled(uid: string, disabled: boolean): Promise<void> {
  await _setUserDisabled({ uid, disabled });
}

export async function setUserRole(uid: string, role: UserRole): Promise<void> {
  await _setUserRole({ uid, role });
}

export async function reassignPatient(patientId: string, newOwnerId: string): Promise<void> {
  await _reassignPatient({ patientId, newOwnerId });
}

export async function createTherapist(email: string, password: string, displayName?: string): Promise<string> {
  const res = await _createTherapist({ email, password, displayName });
  return res.data.uid;
}

export async function updateTherapist(uid: string, email: string, displayName?: string): Promise<void> {
  await _updateTherapist({ uid, email, displayName });
}
